module.exports = () => ({
  ".section": {
    "@apply ds-w-full ds-my-lg md:ds-mt-5xl ds-py-[4rem] lg:ds-px-[2rem]": {},
  },
  ".cards": {
    "@apply ds-max-w-[1440px] ds-mx-auto md:ds--mt-5xl ds-grid ds-grid-cols-1 md:ds-grid-cols-2 lg:ds-grid-cols-3 ds-gap-xs md:ds-gap-sm lg:ds-gap-xl":
      {},
  },
  ".card": {
    "@apply ds-mb-xl md:ds-mb-0 md:ds-px-xs lg:ds-px-lg lg:even:ds-col-start-2": {},
  },
  ".card > header": {
    "@apply ds-px-lg md:ds-pt-[7rem] ds-font-bold ds-text-6xl ds-leading-2xl": {},
  },
  ".card > p": {
    "@apply ds-px-lg ds-pt-xl ds-text-base ds-leading-base": {},
  },
  ".card > footer": {
    "@apply ds-px-lg ds-inline-block ds-py-sm ds-font-medium": {},
  },
});
